import { render, staticRenderFns } from "./ModalContent.vue?vue&type=template&id=66f775be&scoped=true"
import script from "./ModalContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalContent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ModalContent.vue?vue&type=style&index=0&id=66f775be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f775be",
  null
  
)

export default component.exports